import React from 'react'
import getDisplayName from 'lib/get-display-name'
import { Consumer } from './context'

/**
 * Higher order component to wrap components with a `user` and `refreshUser` prop
 */
export default function withUserContext(Component) {
  return class WithUserContext extends React.Component {
    static displayName = `WithUserContext(${getDisplayName(Component)})`

    render() {
      return (
        <Consumer>
          {({ refreshUser, user }) => <Component {...this.props} refreshUser={refreshUser} user={user} />}
        </Consumer>
      )
    }
  }
}
